<template>
    <!-- 创建工艺流程 -->
    <div style="text-align: left">
        <el-row style="margin: 10px 3px">
            <el-button @click="open" size="mini" type="primary" icon="el-icon-circle-plus">新增流程</el-button>
        </el-row>
        <el-dialog
                @closed="closed"
                :append-to-body="true"
                width="65%"
                :visible.sync="show"
                title="新增工艺流程">
            <el-form ref="createForm" :model="formData" :rules="rules" label-width="auto">
                <el-form-item prop="name" size="mini" label="名称:">
                    <el-input v-model="formData.name"></el-input>
                </el-form-item>
                <el-form-item prop="craftprocessstep_set" size="mini" label="工艺流程路线:">
                    <el-checkbox-group v-model="formData.craftprocessstep_set" size="mini">
                        <el-checkbox style="margin: 3px 20px 3px 0" v-for="craftInfo in craftInfoArray"
                                     :disabled="!craftInfo.is_using" :label="craftInfo" border :key="craftInfo.id"
                                     :value="craftInfo.id">
                            {{ craftInfo.name }} <span v-if="craftInfo.is_must" class="text-success">[必选]</span>
                        </el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
            </el-form>
            <el-divider></el-divider>
            <el-row>
                <el-tag
                        style="margin:4px"
                        effect="plain"
                        type="primary"
                        size="mini"
                        v-for="(craftStep, index) in formData.craftprocessstep_set">
                    {{ index + 1 }}.{{ craftStep.name }}
                </el-tag>
            </el-row>
            <div slot="footer" class="dialog-footer">
                <el-button :loading="loading" @click="finishClick" size="mini" type="primary">
                    确 定
                </el-button>
                <el-button size="mini" @click="close">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {mapGetters,mapMutations} from 'vuex'

    export default {
        name: "CreateCraftProcess",
        data() {
            const needCraftsValidator = (rule, value, callback) => {
                // 复制一份 mustCrafts 到 map 中
                const needCraftMap = new Map()
                this.mustCrafts.forEach(mustCraft=>{
                    needCraftMap.set(mustCraft.id,mustCraft)
                })

                value.forEach(selectCraft => {
                    if(needCraftMap.has(selectCraft.id)){
                        needCraftMap.delete(selectCraft.id)
                    }
                })
                if(needCraftMap.size > 0){
                     callback(new Error(`您有 ${needCraftMap.size} 个必选工艺！`))
                }else {
                    callback()
                }
            }
            return {
                show: false,
                loading:false,

                formData: {
                    name: '', // 工艺流程名称
                    craftprocessstep_set: [], // 流程的步骤
                    selected: true, // 是否可用
                },

                rules: {
                    name: [
                        {required: true, message: '必填项', trigger: 'blur'},
                    ],
                    craftprocessstep_set: [
                        {validator: needCraftsValidator, trigger: 'blur'},
                    ]
                },
            }
        },
        computed: {
            /**
             * 必选的 craft 工艺步骤
             */
            mustCrafts(){
                const ret = [];
                this.craftInfoArray.forEach(craft => {
                    if(craft.is_must && craft.is_using){
                        ret.push(craft)
                    }
                });
                return ret
            },

            /**
             * 所有的工艺信息
             */
            craftInfoArray() {
                return this.craftInfoData['craftInfoArray']
            },
            ...mapGetters(['craftInfoData',])
        },
        methods: {
            open() {
                this.show = true
            },

            close() {
                this.show = false

            },
            closed() {
                this.formData.name = ''
                this.formData.craftprocessstep_set = []
                this.$refs.createForm.clearValidate()
            },

            /**
             * 点击完成按钮
             */
            finishClick(){
                this.$refs.createForm.validate((validated)=>{ // 对表单发起验证
                    if(validated){  // 验证结果通过，则发起请求，创建数据
                        this._sendCreateRequest()
                    }
                })
            },

            /**
             * 发起创建请求，并处理返回的数据
             */
            _sendCreateRequest(){
                // 创建 CraftProcess 的 API 接口地址
                const url = this.$const.craftProcessUrl

                this.loading = true
                const craftprocessstep_set = []
                let index = 1
                this.formData.craftprocessstep_set.forEach(craftprocessstep => {
                    craftprocessstep_set.push({
                        index:index,
                        craft:craftprocessstep.id,
                    })
                    index += 1
                })
                const data = {
                    name:this.formData.name,
                    craftprocessstep_set:craftprocessstep_set,
                }
                this.$postRequest(url,data)
                    .then(response=>{
                        this.loading = false

                        // 将返回数据添加到公共存储的 state 中
                        this.addCraftProcesses([response.data])
                        this.close()
                        this.$message({
                            type:'success',
                            showClose:true,
                            message:'创建工艺流程成功！'
                        })
                    })
                    .catch(()=>{
                        this.loading = false
                    })
            },
            ...mapMutations(['addCraftProcesses'])
        },

    }
</script>

<style scoped>

</style>